import axios from "axios";

// Action Types - reuse existing DRS types to work with existing reducer
export const FETCH_RETAIL_EBT_LOGS_REQUEST = "FETCH_RETAIL_EBT_LOGS_REQUEST";
export const FETCH_RETAIL_EBT_LOGS_SUCCESS = "FETCH_RETAIL_EBT_LOGS_SUCCESS";
export const FETCH_RETAIL_EBT_LOGS_FAILURE = "FETCH_RETAIL_EBT_LOGS_FAILURE";

// Action Creators
export const fetchRetailEbtLogsRequest = () => ({
  type: FETCH_RETAIL_EBT_LOGS_REQUEST,
});

export const fetchRetailEbtLogsSuccess = (data, total) => ({
  type: FETCH_RETAIL_EBT_LOGS_SUCCESS,
  payload: {
    data,
    total
  }
});

export const fetchRetailEbtLogsFailure = (error) => ({
  type: FETCH_RETAIL_EBT_LOGS_FAILURE,
  payload: error
});

// Thunk Action Creator
export const fetchRetailEbtLogs = (query) => {
  return async (dispatch) => {
    dispatch(fetchRetailEbtLogsRequest());
    try {
      if (!query) {
        query = "?license=1";
      } else {
        query += "&license=1";
      }
      const response = await axios.get(`/ebt_logs${query}`);
      dispatch(fetchRetailEbtLogsSuccess(response.data.data, response.data.total));
    } catch (error) {
      dispatch(fetchRetailEbtLogsFailure(error.message));
    }
  };
};
